import React, { useState } from 'react';

import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import './styles.scss'

SwiperCore.use([Navigation, Pagination]);


const GreetingCard = ({ file, pathPrefix, checked = false }) => {
    const radioId = `rdo_${file}`

    return (
        <>
            <input type="radio" id={radioId} name="rdo_cards" checked={checked} onChange={() => {}}/>

            <label htmlFor={radioId} >
                <img src={require(`../../images/${pathPrefix}/${file}`)} alt={file} />
            </label>
        </>
    )
}

const CardSelector = (props) => {
    const { cardsCatalog, onCardSelected } = props
    const [selected, setSelected] = useState(cardsCatalog.cards[0].file)

    let initialSlide = cardsCatalog.cards.findIndex(card => card.file === selected)
    if (initialSlide === -1) initialSlide = 0

    return (
        <Swiper className="card-swiper-container"
            initialSlide={initialSlide}
            draggable={false}
            autoplay={false}
            allowTouchMove={false}
            slidesPerView={'auto'}
            spaceBetween={8}
            centeredSlides
            freeMode={false}
            height={400}
            navigation
            pagination={{
                clickable: false,
                type: 'fraction'
            }}
            breakpoints={{
                640: {
                    slidesPerView: 2,
                }
            }}            
        >
            {cardsCatalog.cards.map((item, i) => {
                return (
                    <SwiperSlide key={`scard_${i}`}
                        onClick={() => {
                            setSelected(item.file)
                            onCardSelected(item.file)
                        }}>

                        <GreetingCard
                            pathPrefix={cardsCatalog.pathPrefix}
                            file={item.file}
                            checked={item.file === selected}
                        />
                    </SwiperSlide>
                )
            })}
        </Swiper>
    )
};

export default CardSelector;